import styled from "styled-components";
import { device } from "../../../../../utils/device";

export const NoDtl = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(238, 238, 238, 0.8);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 1;
  @media ${device.mobileS} {
    width: calc(100% - 20px);
    left: 10px;
  }
`;
export const NoDtlIcon = styled.div`
  width: 80px;
  margin-bottom: 20px;
  @media ${device.mobileS} {
    
  }
`;
export const NoDtlHdng = styled.h4`
  font-size: 24px;
  font-weight: 900;
  margin-bottom: 14px;
  @media ${device.mobileS} {
    font-size: 20px;
    max-width: 220px;
  }
`;
export const NoDtlCta = styled.a`
  font-size: 16px;
  font-weight: 900;
  color: #008cff;
  cursor: pointer;
  @media ${device.mobileS} {
    
  }
`;